import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
    filtersToElasticQuery,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters,
    Configuration,
    ContactsApi,
    ContactsContactJsonldContactRead,
    ContactsApiGetContactsContactsCollectionRequest,
} from '../../../openApi/ApiTiers';
import { CONTACT_SLICE_NAME, TIERS_REDUCER_NAME } from '../constants';

export type Contacts = ContactsContactJsonldContactRead & Record<string, unknown>;

export const mapperContacts = function (contacts: Contacts) {
    return {
        ...contacts,
    } as Contacts;
};
export function createContactSlice(configuration: ConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new ContactsApi(conf);

    // To improve, not implemented yet
    const fetchContactsCollection: FetchCollectionData<Contacts> = ({
        search,
        pagination,
        filters,
        orders,
        xIdSociete,
        options,
    }) => {
        let tiersId2: number[] | undefined;
        if (filters.tiersId2) {
            tiersId2 = filters.tiersId2 as number[];
        }

        let aditionalMatch;
        if (search && search !== '') {
            aditionalMatch = [
                {
                    query_string: {
                        query: `**${search}**`,
                        fields: ['nomContact', 'prenomContact'],
                    },
                },
            ];
        }
        let requestParameters: ContactsApiGetContactsContactsCollectionRequest = {
            xIdSociete,
            page: pagination.page + 1,
            tiersId2,
        };
        if (aditionalMatch) {
            requestParameters = {
                ...requestParameters,
                q: filtersToElasticQuery(
                    {
                        ...filters,
                    },
                    aditionalMatch,
                    orders,
                ),
            };
        }
        return api
            .getContactsContactsCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<Contacts>>;
    };

    // To improve, not implemented yet
    const fetchContactsItem: FetchItemDataType<Contacts> = ({
        idItem,
        // search,
        // pagination,
        // filters,
        // orders,
        xIdSociete,
        // rootstate,
        options,
    }) =>
        api
            .getContactContactsItem(
                {
                    id: `${idItem}`,
                    xIdSociete,
                },
                options,
            )
            .then((res) => res.data) as Promise<Contacts>;

    const { slice: contactsSlice, dataSourcesThunks: contactsDataSourcesThunks } =
        SliceFactory.createSlice<Contacts, Contacts>(
            CONTACT_SLICE_NAME,
            TIERS_REDUCER_NAME,
            ['export'],
            fetchContactsCollection,
            fetchContactsItem,
            mapperContacts,
            {},
            undefined,
        );

    return { contactsSlice, contactsDataSourcesThunks };
}
